import React, { useState } from 'react';
import css from './ProgressBar.css';

export default function Step(props) {
    // const Step = props => {
    return (
        <div className={css.stepBlock}>
            {/* <div className={css.circleWrapper} onClick={props.updateStep(props.index)}> */}
            <div className={css.circleWrapper}>
                <div className={css.circle}>{props.index + 1}</div>
            </div>
            <span>{props.label}</span>
        </div>
    )
}